export default "__VITE_ASSET__e8832d7e__"